import React, { Fragment } from 'react';
import AbstractComponent from '../AbstractComponent';
import InputSearch from '../layout/input/InputSearch';
import ModalPesquisa from '../layout/modal/ModalPesquisa';
import ModalAlerta from '../layout/modal/ModalAlerta';
import FilterTypeEnum from '../layout/filter/FilterTypeEnum';
import Button from '../layout/button/Button';
import Table from '../layout/table/Table';
import TableTypeEnum from '../layout/table/TableTypeEnum';
import AlignEnum from '../layout/table/AlignEnum';
import Preload from '../layout/preload/Preload';

import AparelhoService from '../../service/AparelhoService';
import AutenticarService from '../../service/AutenticarService';
import NotificacaoAparelhoService from '../../service/NotificacaoAparelhoService';

import FormCodeEnum from '../../helper/enumerador/FormCodeEnum';

class Aparelhos extends AbstractComponent { 
    constructor(props) {
        super(props);                     

        this.state = {
            modalAparelho: false,            

            preloadFilter: false,

            preloadSearch: false,

            preloadSubmit: false,

            erroFilter: {
                message: '',
                code: 0
            },            

            erro: {
                message: '',
                code: 0
            },       
            
            checkAll: false,

            head: [
                {nome: 'Uuid', campo: 'uuid_aparelho', width: '30%'},
                {nome: 'Cliente', campo: 'nome_cliente', width: '50%'},                
                {nome: 'Push Notification', campo: 'push_notification', width: '5%', type: TableTypeEnum.CHECKBOX, align: AlignEnum.CENTER, readonly: true},
                {nome: 'Status', campo: 'status', width: '13%'}
            ],             

            headFilter: [
                {nome: 'Uuid', campo: 'uuid', width: '25%'},
                {nome: 'Nome do cliente', campo: 'nome', width: '60%'},                
                {nome: 'Push Notification', campo: 'push_notification', width: '5%', type: TableTypeEnum.CHECKBOX, align: AlignEnum.CENTER, readonly: true},
                {nome: 'Selecionar', campo: 'marcar', width: '10%', type: TableTypeEnum.CHECKBOX, align: AlignEnum.CENTER}
            ],             

            bodyFilter: [],

            aparelho: {
                uuid_aparelho: '',
                documento_cliente: '',
                nome: '',
                token_api_mensagem: '',
                buscar: 0                
            },

            filter: [
                {nome: 'Uuid', campo: 'uuid', valor: "", type: FilterTypeEnum.TEXT, md: "5", xs: "5", sm: "5", lg: "5"},                
                {nome: 'Nome do cliente', campo: 'nome', valor:"", type: FilterTypeEnum.TEXT, md: "5", xs: "5", sm: "5", lg: "5"}                
            ],

            form: {
                id: '',
                ativo: "Sim",                             
                uuid_notificacao_cab: '',
                documento_cliente: '',
                nome_cliente: '',
                token_api_mensagem: '',
                persistencia: {
                    data_criacao: null,
                    alterado_em: null,
                    criado_por: this.props.usuario.nome,
                    alterado_por: this.props.usuario.nome
                },                
            }
        }        
    }                

    onFilterChange(index, e) {
        var filter = this.state.filter;

        filter[index].valor = e.target.value;        

        this.setState({filter: filter});
    }    

    onFilterCallback(itens) {
        if(!Array.isArray(itens)) {
            let aparelho = this.state.aparelho;

            aparelho.uuid_aparelho = itens.uuid;        
            aparelho.documento_cliente = itens.documento_cliente; 
            aparelho.nome = itens.nome;
            aparelho.push_notification = itens.push_notification;
            aparelho.token_api_mensagem = itens.token_api_mensagem;                            

            this.setState({ 
                aparelho: aparelho,
                modalAparelho: false, 
                bodyFilter: []
            });

            return ;
        }

        let lista = [];

        itens.forEach(element => {
            if(element.marcar === 0) 
                return ;

            let form = {};

            form.ativo = "Sim";        
            form.uuid_notificacao_cab = this.props.form.uuid;
            form.uuid_aparelho = element.uuid;
            form.documento_cliente = element.documento_cliente;
            form.nome_cliente = element.nome;
            form.push_notification = element.push_notification;
            form.token_api_mensagem = element.token_api_mensagem;

            form.persistencia = {};
            form.persistencia.criado_por = this.props.usuario.nome;
            form.persistencia.alterado_por = this.props.usuario.nome; 

            lista.push(form);                     
        });

        if(lista.length === 0) {
            this.setState({
                erroFilter: {
                    message: 'Você deve selecionar pelo menos 1 aparelho',
                    code: FormCodeEnum.DEFAULT
                },
                bodyFilter: []
            });

            return;
        }        

        if(lista.length === 1) {            
            let form = {};

            form.ativo = "Sim";        
            form.uuid_notificacao_cab = this.props.form.uuid;            
            form.uuid_aparelho = lista[0].uuid_aparelho;
            form.documento_cliente = lista[0].documento_cliente;
            form.nome_cliente = lista[0].nome_cliente;
            form.push_notification = lista[0].push_notification;
            form.token_api_mensagem = lista[0].token_api_mensagem;

            form.persistencia = {};
            form.persistencia.criado_por = this.props.usuario.nome;
            form.persistencia.alterado_por = this.props.usuario.nome;             

            this.gravar(form);

            return; 
        }

        this.gravar(lista);
    }

    onFilterButtonClick() {
        this.setState({
            erroFilter: {
                message: '',
                code: 0
            },
            preloadFilter: true,
            bodyFilter: []
        }); 
        
        let form = {};

        form.idCliente = AutenticarService.getIdEmpresa();
        form.filter = this.state.filter;  
        form.uuid_notificacao_cab = this.props.form.uuid;            

        AparelhoService.listar(            
            form
        ).then(resposta => {
            this.setState({               
                preloadFilter: false,
                bodyFilter: resposta.data
            });
        }).catch(erro => {
            this.setState({
                erroFilter: this.trataErro(erro),
                preloadFilter: false
            });
        })
    }

    onFilterClearClick() {
        var filter = this.state.filter;
        let filterClean = [];

        filter.forEach(element => {
            element.valor = '';
        
            filterClean.push(element);
        });

        this.setState({filter: filterClean, bodyFilter: []});
        this.foco('uuid');
    }        

    onEnter() {          
        if((this.state.aparelho.uuid === undefined)||(this.state.aparelho.uuid === '')||(this.state.aparelho.buscar === 0))
            return ;

        this.setState({
            erro: {
                message: '',
                code: 0
            },
            preloadSearch: true
        });

        let form = {};        

        form.idCliente = AutenticarService.getIdEmpresa();
        form.uuid_notificacao_cab = this.props.form.uuid;        
        
        let filter = this.state.filter;        

        filter[0].valor = this.state.aparelho.uuid;

        form.filter = filter;

        AparelhoService.listar(            
            form
        ).then(resposta => {            
            this.onFilterCallback(resposta.data[0]);

            this.setState({                        
                preloadSearch: false
            });
        }).catch(erro => {
            this.setState({
                erro: this.trataErro(erro),
                preloadSearch: false
            });
        }) 
    }

    onChange(e) {        
        var aparelho = this.state.aparelho;
                        
        aparelho[e.target.name] = e.target.value;  
        aparelho['buscar'] = 1;             

        this.setState({ aparelho: aparelho });
    }      

    gravar(form) {
        this.setState({preloadSubmit: true});

        NotificacaoAparelhoService.gravar(
            form
        ).then(resposta => {                 
            this.onUpdate(resposta.data, undefined);

            this.setState({
                modalAparelho: false, 
                checkAll: 0,
                bodyFilter: [],
                preloadSubmit: false
            });            
        }).catch(erro => {
            this.setState({
                erro: this.trataErro(erro),
                preloadSubmit: false
            });
        });
    }

    add() {           
        this.setState({
            erro: {
                message: '',
                code: 0
            },
            preloadSubmit: true
        });

        let form = {};

        form.ativo = "Sim";        
        form.uuid_notificacao_cab = this.props.form.uuid;
        form.uuid_aparelho = this.state.aparelho.uuid_aparelho;
        form.documento_cliente = this.state.aparelho.documento_cliente;
        form.nome_cliente = this.state.aparelho.nome;
        form.token_api_mensagem = this.state.aparelho.token_api_mensagem;
        
        form.persistencia = {};

        form.persistencia.criado_por = this.props.usuario.nome;
        form.persistencia.alterado_por = this.props.usuario.nome;                
        
        this.gravar(form);
    }   
    
    onUpdate(form, index) {        
        this.props.onUpdatePushAparelho(form, index);

        let aparelho = this.state.aparelho;

        aparelho.uuid_aparelho = '';
        aparelho.documento_cliente = '';
        aparelho.nome = '';
        aparelho.token_api_mensagem = '';  
        aparelho.buscar = 0;                 

        this.setState({                
            aparelho: aparelho,                      
            preloadRemover: false,
            preloadSubmit: false,            
        });        
    }

    delete(item, index) {        
        this.setState({
            erro: {
                message: '',
                code: 0
            },
            preloadRemover: true
        });

        NotificacaoAparelhoService.delete(
            item.id
        ).then(() => {
            this.onUpdate(undefined, index);                        
        }).catch(erro => {
            this.setState({
                erro: this.trataErro(erro),
                preloadRemover: false
            });
        });
    }

    onCheck(index) {
        let body = this.state.bodyFilter;

        body[index].marcar = (body[index].marcar === 0 ? 1 : 0);        

        this.setState({
            bodyFilter: body,
            checkAll: (body[index].marcar === 0 ? false : this.state.checkAll)
        });
    }    

    onCheckAll() {
        let body = this.state.bodyFilter;
        let newBody = [];        
        const checkAll = (this.state.checkAll ? false : true);

        body.forEach(element => {
            element.marcar = checkAll;
            newBody.push(element);
        });
        
        this.setState({
            bodyFilter: newBody,
            checkAll: checkAll            
        });
    }    

    render() {
        return(    
            <Fragment>  
                <Preload show={this.state.preloadRemover || this.state.preloadSubmit} />

                <ModalAlerta
                    show={this.state.erro.code !== 0}
                    header="Alerta"
                    texto={this.state.erro.message}
                    fechar={() => this.setState({erro: this.finalizaErro(this.state.erro)})}
                />

                <ModalPesquisa
                    show={this.state.modalAparelho}
                    header="Lista de aparelhos"
                    filter={this.state.filter}
                    erroFilter={this.state.erroFilter}
                    preloadFilter={this.state.preloadFilter}
                    defaultFocoFilter='uuid'

                    head={this.state.headFilter}
                    body={this.state.bodyFilter}   
                
                    callback={true}  
                    checkAll={this.state.checkAll}               
                    
                    fechar={() => this.setState({modalAparelho: false, bodyFilter: {}})}
                    onFilterChange={(index, e) => this.onFilterChange(index, e)}
                    onFilterButtonClick={() => this.onFilterButtonClick()}
                    onFilterClearClick={() => this.onFilterClearClick()}
                    onClearErroFilter={() => this.setState({erroFilter: this.finalizaErro(this.state.erroFilter)})}
                    onCheck={(index) => this.onCheck(index)}
                    onCheckAll={() => this.onCheckAll()}
                    onCallback={(item) => this.onFilterCallback(item)}
                />                

                <InputSearch
                    md={10} 
                    xs={12} 
                    sm={10} 
                    lg={10}
                    mainClassName="col-md-5 col-sm-5 col-lg-5 col-xs-12"
                    md2={7}
                    id="uuid"
                    nome="uuid"                    
                    value={this.state.aparelho.uuid}
                    result={this.state.aparelho.nome}                    
                    preload={this.state.preloadSearch}
                    disabled={this.props.form.status !== 'EM EDICAO'}
                    onChange={e => this.onChange(e)}
                    onButtonClick={() => this.setState({modalAparelho: true})}
                    onEnter={() => this.onEnter()}
                    onBlur={() => this.onEnter()}
                >
                    Aparelho
                </InputSearch>                     
                                
                <div className="col-md-2
                                col-sm-2
                                col-lg-2
                                col-xs-12">                    
                    <Button 
                        className={"btn btn-success"}
                        type="button"       
                        style={{
                            width: '100%',
                            marginTop: '24px',
                        }}
                        preload={this.state.preloadSubmit}
                        disabled={(this.state.aparelho.nome === '' || this.state.preloadSearch)}
                        onClick={() => {this.add()}}
                    >
                        <i className="fas fa-plus" />

                        &nbsp;
                        Adicionar
                    </Button>
                </div>                

                {
                    this.props.form.notificacao_aparelho.length > 0 &&                
                    <Table
                        ref={ref => this.table = ref}
                        head={this.state.head}
                        body={this.props.form.notificacao_aparelho}
                        
                        disabled={this.props.form.status !== 'EM EDICAO'}
                        cadastro={this.props.cadastro}
                        editar={ this.props.editar }
                        link={ this.props.link }                    

                        remover={(item, index) => this.delete(item, index)}

                        onCellClick={() => this.props.onCellClick()}
                        route={(route) => this.props.route(route)}                                            
                    /> 
                }
            </Fragment>
        )
    }
}

export default Aparelhos;